module.exports = __webpack_public_path__ + "media/images/badges-c035bbb9.jpeg";